import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getCreditEvaluationsCurrent() {
    return defaultClient.get('/evaluations/credit-evaluations/current/')
  },
  postCreditEvaluations() {
    return defaultClient.post('/evaluations/credit-evaluations/')
  },
  postCreditEvaluateDetail(uuid) {
    return defaultClient.post(`/evaluations/credit-evaluations/${uuid}/evaluate/`)
  },
}
